import React from 'react';

import { Box, Divider, Paper } from '@mui/material';

import CalendarRateView from './CalendarRateView';
import ChartSection from './ChartSection';
import ProblemDateRangesSection from './ProblemDateRangesSection';
import SummarySection from './SummarySection';
import { SECTION_SX } from './constants';
import { RateStrategyPanelProps, defaultRateStrategyPanelProps } from './rateStrategyPanel';
import { ParityAnalysis, RevenueHooks } from './types';

interface Props {
  analysis: ParityAnalysis;
  revenueHooks?: RevenueHooks | null;
  rateStrategy?: Partial<RateStrategyPanelProps>;
  onGenerateEmail?: () => void;
  onExportPdf?: () => void;
}

export default function ParityReport({
  analysis,
  revenueHooks = null,
  rateStrategy: rateStrategyPartial,
  onGenerateEmail,
  onExportPdf,
}: Props) {
  const a = analysis;
  const rateStrategy: RateStrategyPanelProps = {
    ...defaultRateStrategyPanelProps,
    ...rateStrategyPartial,
  };

  return (
    <Box>
      <Box data-pdf-section>
        <SummarySection
          analysis={a}
          revenueHooks={revenueHooks}
          onGenerateEmail={onGenerateEmail}
          onExportPdf={onExportPdf}
        />

        <Box data-html2canvas-ignore>
          <Divider sx={{ my: 3 }} />
        </Box>

        <ChartSection analysis={a} rateStrategy={rateStrategy} />
      </Box>

      <Box data-pdf-section data-pdf-page-break-before>
        <Divider sx={{ my: 3 }} />

        <Paper elevation={0} sx={SECTION_SX}>
          <CalendarRateView analysis={a} />
        </Paper>

        {a.dateRanges.length > 0 && (
          <>
            <Divider sx={{ my: 3 }} />
            <ProblemDateRangesSection analysis={a} />
          </>
        )}
      </Box>
    </Box>
  );
}
